<template>
    <div class="fixed-top filter"> 
      <nav class="navbar-expand-sm navbar-dark"> 
        <div class="container-fluid d-flex justify-content-start"> 
          <div>
            <!-- Two links side by side -->
            <!-- <router-link to="/dashboard/alarm/all" class="link-item" :class="{ active: $route.path === '/dashboard/alarm/all' }">All</router-link> -->
            <router-link to="/dashboard/sensor/overview" class="link-item" :class="{ active: $route.path === '/dashboard/sensor/overview' }">Sensor Overview</router-link>
            <router-link to="/dashboard/device/analytics" class="link-item" :class="{ active: $route.path === '/dashboard/device/analytics' }">Device Analytics</router-link>
            <!-- <router-link to="/dashboard/alarm/component" class="link-item" :class="{ active: $route.path === '/dashboard/alarm/component' }">Component</router-link> -->
          </div>
        </div>
      </nav>
    </div>
  </template>
  
  <script>
  export default {
    name: "iot-insight-tabs",
    data() {
      return {
      };
    },
    mounted() {
    },
    methods: {
    },
  };
  </script>
  
  <style>
  .link-item {
    margin-right: 15px; /* Adjust as needed */
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
    color: black;
  }
  
  .active {
    /* Define your active styles here */
    color: #1371E7;
  }
  </style>
  